import React from 'react';
import { forYouPageDataHooks } from './ForYouPage.dataHooks';
import s from './ForYouPage.scss';
import { ForYouGenericPage } from './ForYouGenericPage/ForYouGenericPage';

interface ForYouPageProps {
  dataHook?: string;
}

export const ForYouPage: React.FC<ForYouPageProps> = ({ dataHook }) => (
  <div className={s.root} data-hook={dataHook}>
    <ForYouGenericPage dataHook={forYouPageDataHooks.genericPage()} />
  </div>
);
